import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/logo.png';
import { User, Building2, ClipboardList, LogOut } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useAuthModal } from '../../contexts/AuthModalContext';
import toast from 'react-hot-toast';

export default function PublicHeader() {
  const { currentUser, userProfile, logout } = useAuth();
  const { openClientAuth, openGerantAuth } = useAuthModal();
  const navigate = useNavigate();

  async function handleLogout() {
    await logout();
    toast.success('Déconnecté');
    navigate('/');
  }

  return (
    <header style={{
      position: 'sticky', top: 0, zIndex: 90,
      background: 'white', borderBottom: '1px solid var(--border)',
      boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
    }}>
      <div style={{
        maxWidth: 1200, margin: '0 auto', padding: '0.75rem 1.25rem',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem',
      }}>
        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', cursor: 'pointer', flexShrink: 0 }} onClick={() => navigate('/')}>
          <img src={logo} alt="ResiPro CI" style={{ width: 36, height: 36, borderRadius: 9, objectFit: 'contain' }} />
          <span className="hide-mobile" style={{ fontFamily: 'Poppins', fontWeight: 700, fontSize: '1.05rem', color: 'var(--primary)' }}>
            ResiPro CI
          </span>
        </div>

        {/* Actions */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexShrink: 0 }}>
          {currentUser && userProfile?.role === 'client' ? (
            <>
              <button className="btn btn-outline btn-sm" onClick={() => navigate('/client/reservations')}>
                <ClipboardList size={15} /> <span className="hide-mobile">Mes réservations</span>
              </button>
              <button className="btn btn-ghost btn-sm" onClick={() => navigate('/client/profil')}>
                <User size={15} /> <span className="hide-mobile">Mon profil</span>
              </button>
              <button className="btn btn-ghost btn-sm" style={{ color: 'var(--danger)' }} onClick={handleLogout} title="Déconnexion">
                <LogOut size={15} />
              </button>
            </>
          ) : (
            <>
              <button className="btn btn-outline btn-sm" onClick={() => openClientAuth()}>
                <User size={15} /> <span className="hide-mobile">Connexion / Inscription</span>
              </button>
              <button className="btn btn-primary btn-sm" onClick={openGerantAuth}>
                <Building2 size={15} /> <span className="hide-mobile">Espace Gérant</span>
              </button>
            </>
          )}
        </div>
      </div>

      <style>{`
        @media (max-width: 640px) {
          .hide-mobile { display: none; }
        }
      `}</style>
    </header>
  );
}
